import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '../stores/auth.store';

function CheckAuth() {
  const location = useLocation();
  const { token } = useAuthStore();

  const accessToken = token || localStorage.getItem('accessToken');

  if (accessToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default CheckAuth;
